import React, { useEffect } from "react";
import * as environment from "../../environment";
import { useState } from "react"
import { Box, Stack, Typography, IconButton, Tooltip } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import AppIcon from '@mui/icons-material/RocketLaunch';

import NewChatIcon from '@mui/icons-material/EditDocument';
import ProfileIcon from '@mui/icons-material/AccountCircle';
import DevToolsIcon from '@mui/icons-material/AutoAwesome';
import { useAuth } from "../../hooks/useAuth";
import ProfileDialog from '../home/ProfileDialog';

import { loadUserInfoAsync, selectUserInfo } from "../../state/chatSlice";
import { useDispatch, useSelector } from "react-redux";
import { contactSupport } from "../../services/user";
import DevToolsDialog from "./DevToolsDialog";

function ChatHeader({ onClear, clearDisabled, isAdmin }) {
    const { logout } = useAuth();
    const theme = useTheme();
    const dispatch = useDispatch();

    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [profileOpen, setProfileOpen] = useState(false);
    const [devToolsOpen, setDevToolsOpen] = useState(false);
    const [sendingFeedback, setSendingFeedback] = useState(false);

    const userInfo = useSelector(selectUserInfo);

    useEffect(() => {
        dispatch(loadUserInfoAsync());
    }, [dispatch]);

    return (
        <Stack
            p={1}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
            spacing={1}>
            <AppIcon fontSize="large" />
            <Typography variant="h6" gutterBottom>
                SuperFastGPT
            </Typography>
            <Box sx={{ flexGrow: 1 }}></Box>
            {isAdmin && <Tooltip title="Dev Tools">
                <IconButton onClick={() => {
                    setDevToolsOpen(true)
                }}>
                    <DevToolsIcon />
                </IconButton>
            </Tooltip>}
            <Tooltip title="New Chat">
                <IconButton
                    disabled={clearDisabled}
                    onClick={onClear}>
                    <NewChatIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Profile">
                <IconButton onClick={
                    () => {
                        setProfileOpen(true);
                    }
                }>
                    <ProfileIcon />
                </IconButton>
            </Tooltip>
            <DevToolsDialog
                open={devToolsOpen}
                onClose={() => setDevToolsOpen(false)}
                fullScreen={fullScreen}
            >
            </DevToolsDialog>
            <ProfileDialog
                fullScreen={fullScreen}
                open={profileOpen}
                onClose={() => setProfileOpen(false)}
                onLogout={
                    () => {
                        setProfileOpen(false);
                        logout();
                    }
                }

                userName={`${userInfo.firstName} ${userInfo.lastName}`}
                userEmail={userInfo.email}
                messagesRemaining={userInfo.messagesRemaining?.toLocaleString()}
                version={environment.default.appVersion}
                onSendFeedback={(feedback) => {
                    setSendingFeedback(true);
                    contactSupport({
                        email: userInfo.email,
                        appVersion: environment.default.appVersion,
                        name: `${userInfo.firstName} ${userInfo.lastName}`,
                        problem: feedback,
                    })
                        .finally(() => {
                            setSendingFeedback(false);
                        });
                }}
                sendingFeedback={sendingFeedback}
            />
        </Stack>
    );
}

export default ChatHeader;